import $ from "jquery";
import Cookies from "js-cookie";

import utils from "../helpers/utils";
import { openModal, closeModal } from "../modules/regions-roles-modal-toggle";

function init(): void {
  $(document).ready(function () {
    $(document).on("click", ".ccc-notify-button:not(.ccc-notify-link)", function () {
      Cookies.remove("ShowCookieHandlerOnNextLoad");
      utils.setCookie("SavedCivicCookies", true, 365);
      window.CookieControl.hide();
    });
    $(document).on("click", ".ccc-notify-link", function () {
      utils.setCookie("ShowCookieHandlerOnNextLoad", true, 365);
    });
  });

  document.addEventListener(
    "CivicScriptsLoaded",
    function () {
      const hasSeenCivic = !!utils.convertToBoolean(Cookies.get("SavedCivicCookies"));
      const hasRoleAndRegion = !!Cookies.get("Role") && !!Cookies.get("Region");
      const showPreferences = !hasSeenCivic && hasRoleAndRegion; // Users who have been using the site at the time cookie manager came into action for the first time
      const canTogglePrompt = !!window.CookieControl && !!window.CookieControl.open;

      // Redirecting from role & region prompt. Show Cookie Preferences modal.
      if (canTogglePrompt && showPreferences) {
        openModal;
      }

      if (
        canTogglePrompt &&
        !!utils.convertToBoolean(Cookies.get("ShowCookieHandlerOnNextLoad")) &&
        !utils.getUrlParameter("noNav")
      ) {
        closeModal;
        window.CookieControl.open();
      }
    },
    false
  );
}

export default { init };
